import { render } from "./DashboardAlmacenes.vue?vue&type=template&id=324c7c33&scoped=true"
import script from "./DashboardAlmacenes.vue?vue&type=script&lang=js"
export * from "./DashboardAlmacenes.vue?vue&type=script&lang=js"

import "./DashboardAlmacenes.vue?vue&type=style&index=0&id=324c7c33&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-324c7c33"]])

export default __exports__